export {
  LOCAL_TUNNEL_BASE_DOMAIN,
  LEGACY_TUNNEL_USERS,
  LOCAL_TUNNEL_ZONE,
  sanitizeTunnelUser,
  resolveLocalTunnelUser,
  resolveLocalTunnelZone,
  isLegacyTunnelUser,
  buildTunnelHost,
  buildTunnelUrl,
  localTunnelCfgEnabled,
  applyLocalTunnelCfg,
} from 'pp-cfg/localTunnelUrls.js';

import { buildTunnelHost, buildTunnelUrl } from 'pp-cfg/localTunnelUrls.js';

/** serverless-offline stage prefix (e.g. /a) — must match cfg.js svcProfile suffix. */
export function tunnelServiceBaseUrl(service, svcProfile, env) {
  const base = buildTunnelUrl(service, env);
  return svcProfile ? `${base}/${svcProfile}` : base;
}

function localTunnelWebCfgEnabled() {
  if (
    (typeof import.meta !== 'undefined' && import.meta.env?.VITE_PB_LOCAL_TUNNEL === '0') ||
    process.env.PB_LOCAL_TUNNEL === '0'
  ) {
    return false;
  }
  const nfWeb =
    (typeof import.meta !== 'undefined' && import.meta.env?.NF_WEB_BASEURL) ||
    process.env.NF_WEB_BASEURL;
  return Boolean(nfWeb || process.env.PB_USE_LOCAL_TUNNEL === '1');
}

/**
 * @param {import('./etc/local.json')} cfg
 * @param {string} profile
 * @param {string|null} svcProfile
 */
export function applyLocalTunnelWebCfg(cfg, profile, svcProfile, cloneDeep) {
  if (profile !== 'local') {
    return cfg;
  }

  if (!localTunnelWebCfgEnabled()) {
    return cfg;
  }

  const next = cloneDeep ? cloneDeep(cfg) : { ...cfg };

  const nfUrl = buildTunnelUrl('nf');
  const connectUrl = buildTunnelUrl('connect-api');
  const polnUrl = tunnelServiceBaseUrl('poln-api', svcProfile);
  const siteUrl = tunnelServiceBaseUrl('site-api', svcProfile);

  if (next.nf) {
    next.nf.app_base_url = nfUrl;
    next.nf.redirect_sign_in = nfUrl;
    next.nf.redirect_sign_out = nfUrl;
    next.nf.connect_api_base_url = connectUrl;
    next.nf.poln_api_base_url = polnUrl;
    let ws = `wss://${buildTunnelHost('connect-api')}`;
    if (svcProfile) {
      ws = `${ws}/${svcProfile}`;
    }
    next.nf.web_socket_url = ws;
  }
  if (next.poln) {
    next.poln.connect_api_base_url = connectUrl;
    next.poln.poln_api_base_url = polnUrl;
  }
  if (next.siteApi) {
    next.siteApi.apiUrl = siteUrl;
  }
  if (next.portal) {
    next.portal.connect_api_base_url = connectUrl;
  }

  return next;
}
